import React, {
  useEffect,
  useState,
  useMemo,
  useRef
} from "react";

import {
  Avatar,
  Box,
  Chip,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  useMediaQuery,
  useTheme,
  Divider,
  Card,
  CardContent,
} from "@mui/material";


import {
  Delete,
  Edit,
  Print,
  PictureAsPdf,
  School,
  Search,
  EventAvailable,
} from "@mui/icons-material";


import Swal from "sweetalert2";

import html2pdf from "html2pdf.js";

import api from "../../api/api";





// ================================
// CONSTANTS
// ================================


const statusColors = {

  present:"success",

  absent:"error",

  late:"warning",

  excuse:"info",

  drop:"error",

};



const rowsPerPage = 6;






const AttendanceData = () => {



  const muiTheme = useTheme();

  const isMobile =
    useMediaQuery(
      muiTheme.breakpoints.down("sm")
    );






  // ================================
  // PROFESSIONAL MAROON THEME
  // ================================


  const theme = {


    primary:"#000000", 

    secondary:"#ff8000",

    light:"#f8f6f4",

    white:"#ffffff",

    border:"#ead9d9",

    text:"#333333",

    muted:"#777777",


  };






  const styles = {


    page:{


      minHeight:"100vh",

      background:theme.light,

      padding:
      isMobile
      ?
      "15px"
      :
      "30px",

    },



    header:{


      background:

      `linear-gradient(
        135deg,
        ${theme.primary},
        ${theme.secondary}
      )`,

      color:"#fff",

      padding:
      isMobile
      ?
      "20px"
      :
      "30px",


      borderRadius:"22px",

      marginBottom:"25px",

      boxShadow:
      "0 10px 30px rgba(128,0,32,.25)",


    },



    mainCard:{


      background:
      theme.white,


      borderRadius:"20px",


      border:
      `1px solid ${theme.border}`,


      boxShadow:
      "0 8px 25px rgba(0,0,0,.08)",


    },



    filterCard:{


      padding:"20px",

      borderRadius:"18px",

      background:"#fff",


      border:
      `1px solid ${theme.border}`,


      marginBottom:"20px",


    },



    tableCard:{


      borderRadius:"20px",

      overflow:"hidden",

      border:
      `1px solid ${theme.border}`,


      boxShadow:
      "0 8px 25px rgba(0,0,0,.06)",


    },



    primaryButton:{


      background:

      `linear-gradient(
        135deg,
        ${theme.primary},
        ${theme.secondary}
      )`,


      color:"#fff",


      borderRadius:"12px",


      textTransform:"none",


      fontWeight:"bold",



      "&:hover":{


        background:
        theme.primary,


      },


    },




    studentCard:{


      marginTop:"25px",


      padding:"20px",


      borderRadius:"20px",


      background:"#fff",


      border:
      `1px solid ${theme.border}`,


      boxShadow:
      "0 8px 25px rgba(0,0,0,.08)",


    }


  };









  // ================================
  // STATES
  // ================================


  const [
    gradeClasses,
    setGradeClasses
  ] = useState([]);



  const [
    selectedClass,
    setSelectedClass
  ] = useState(null);



  const [
    records,
    setRecords
  ] = useState([]);



  const [
    userRole,
    setUserRole
  ] = useState("");



  const [
    search,
    setSearch
  ] = useState("");



  const [
    editRecord,
    setEditRecord
  ] = useState(null);



  const [
    editStatus,
    setEditStatus
  ] = useState("");



  const [
    page,
    setPage
  ] = useState(0);



  const [
    selectedStudent,
    setSelectedStudent
  ] = useState(null);




  const printRef =
    useRef();









  // ================================
  // LOAD USER ROLE
  // ================================


  useEffect(()=>{


    const role =
      localStorage.getItem(
        "user_role"
      )
      ||
      "";



    setUserRole(role);



  },[]);









  // ================================
  // LOAD GRADE CLASSES
  // ================================


  useEffect(()=>{


    const loadClasses =
    async()=>{


      try{


        const privilegedRoles = [

          "admin",

          "vpa",

          "vpi",

          "dean"

        ];



        const isPrivileged =
        privilegedRoles.includes(
          userRole
        );



        const endpoint =
        isPrivileged

        ?

        "/api/grade-classes/"

        :

        "/api/users/teacher-subjects/";





        const response =
        await api.get(endpoint);





        if(isPrivileged){


          const classes =

          Array.isArray(response.data)

          ?

          response.data

          :

          response.data.grade_classes
          ||
          response.data.results
          ||
          [];



          setGradeClasses(classes);



        }

        else{


          setGradeClasses(

            response.data.grade_classes
            ||
            []

          );


        }



      }

      catch(error){


        console.error(error);


        Swal.fire(

          "Error",

          "Unable to load grade classes",

          "error"

        );


      }


    };



    if(userRole)

      loadClasses();



  },[userRole]);









  // ================================
  // FETCH ATTENDANCE RECORDS
  // ================================


  const fetchRecords =
  async()=>{


    try{


      let endpoint =
      "student-attendance/";



      if(selectedClass){


        endpoint =

        `student-attendance/?grade_class=${selectedClass.id}`;


      }





      const response =
      await api.get(endpoint);



      setRecords(
        response.data
      );



    }

    catch(error){


      console.error(error);



      Swal.fire(

        "Error",

        "Unable to load attendance records",

        "error"

      );


    }


  };






  useEffect(()=>{


    fetchRecords();


    setSelectedStudent(null);



  },[
    selectedClass,
    userRole
  ]);









  // ================================
  // SEARCH FILTER
  // ================================


  const filteredRecords =

  useMemo(()=>{


    return records.filter(

      record=>

      (
        record.student_name
        ||
        ""
      )

      .toLowerCase()

      .includes(

        search.toLowerCase()

      )


    );


  },[
    records,
    search
  ]);






  useEffect(()=>{


    setPage(0);


  },[
    filteredRecords.length
  ]);







  const paginatedRecords =

  useMemo(()=>{


    return filteredRecords.slice(

      page * rowsPerPage,

      page * rowsPerPage + rowsPerPage

    );


  },[
    filteredRecords,
    page
  ]);








  const handleChangePage =
  (_,newPage)=>{
    setPage(newPage);
};

 // ================================
  // STUDENT ATTENDANCE SUMMARY
  // ================================
 const {
    summaryCounts,
    hasDropped

  } = useMemo(()=>{


    if(!selectedStudent)


      return {
        summaryCounts:null,
        hasDropped:false
};
  const studentRecords =
    records.filter(
      record=>
      record.student_name ===
      selectedStudent.student_name
    );
    const counts={
      present:0,
      absent:0,
      late:0,
      excuse:0
    };
    let dropped=false;
    studentRecords.forEach(
      record=>{
        const status =
        record.status.toLowerCase();
        if(status in counts)
          counts[status]++;
        if(status==="drop")
          dropped=true;
      }
    );

    return {
      summaryCounts:counts,
      hasDropped:dropped
    };
  },[
    selectedStudent,
    records
  ]);

  const handleStudentClick =
  (record)=>{


    setSelectedStudent(record);


  };


  // ================================
  // DELETE ATTENDANCE
  // ================================


  const handleDelete =
  async(id)=>{


    const result =

    await Swal.fire({


      title:
      "Delete Attendance?",


      text:
      "This action cannot be undone.",


      icon:
      "warning",


      showCancelButton:true,


      confirmButtonColor:
      theme.primary,


      confirmButtonText:
      "Delete"


    });





    if(!result.isConfirmed)

      return;




    try{


      await api.delete(

        `student-attendance/${id}/`

      );



      Swal.fire(

        "Deleted",

        "Attendance removed",

        "success"

      );



      fetchRecords();



    }

    catch(error){


      Swal.fire(

        "Error",

        "Delete failed",

        "error"

      );


    }


  };







  // ================================
  // EDIT HANDLERS
  // ================================


  const openEdit =
  (record)=>{


    setEditRecord(record);


    setEditStatus(
      record.status
    );


  };





  const handleUpdate =
  async()=>{


    try{


      await api.patch(

        `student-attendance/${editRecord.id}/`,

        {

          status:editStatus

        }

      );



      Swal.fire(

        "Updated",

        "Attendance updated",

        "success"

      );



      setEditRecord(null);


      fetchRecords();



    }

    catch(error){


      Swal.fire(

        "Error",

        "Update failed",

        "error"

      );


    }


  };
  // ================================
  // PRINT ATTENDANCE
  // ================================


  const handlePrint = () => {


    const printContents =
      printRef.current.innerHTML;


    const printWindow =
      window.open(
        "",
        "",
        "width=900,height=600"
      );



    printWindow.document.write(`

      <html>

      <head>

      <title>
      Attendance Record
      </title>


      <style>

      body{

        font-family:Arial;

        padding:20px;

      }


      table{

        width:100%;

        border-collapse:collapse;

      }


      th,td{

        border:1px solid #ddd;

        padding:8px;

      }


      th{

        background:#800020;

        color:white;

      }


      </style>


      </head>


      <body>

      ${printContents}

      </body>


      </html>


    `);



    printWindow.document.close();

    printWindow.focus();

    printWindow.print();

    printWindow.close();


  };









  // ================================
  // EXPORT PDF
  // ================================


  const handleExportPDF = () => {



    if(!selectedClass){


      Swal.fire(

        "Select Class",

        "Please select a grade class first.",

        "info"

      );


      return;


    }




    const container =
    document.createElement("div");



    container.style.width="800px";

    container.style.padding="30px";

    container.style.background="#fff";

    container.style.fontFamily="Arial";





    container.innerHTML = `


    <div style="
      text-align:center;
      margin-bottom:20px;
    ">


      <h1 style="
        color:#800020;
        margin:0;
      ">

        Jana L. Williams

      </h1>


      <h3 style="
        color:#a52a2a;
      ">

        Educational Foundation

      </h3>



      <p>

        Attendance Report

      </p>



      <hr/>

    </div>


    `;




    let table = `


    <table style="
      width:100%;
      border-collapse:collapse;
    ">


    <thead>


    <tr style="
      background:#800020;
      color:white;
    ">


    <th>
    Date
    </th>


    <th>
    Student
    </th>


    <th>
    Status
    </th>


    </tr>


    </thead>


    <tbody>


    `;



    paginatedRecords.forEach(
      record=>{


        table += `


        <tr>


        <td style="
        border:1px solid #ddd;
        padding:8px;
        ">

        ${record.date}

        </td>



        <td style="
        border:1px solid #ddd;
        padding:8px;
        ">

        ${record.student_name}

        </td>



        <td style="
        border:1px solid #ddd;
        padding:8px;
        color:#800020;
        font-weight:bold;
        ">

        ${
          record.status
          .charAt(0)
          .toUpperCase()
          +
          record.status.slice(1)

        }

        </td>


        </tr>


        `;



      }
    );



    table +=

    "</tbody></table>";



    container.innerHTML += table;




    container.innerHTML += `


    <div style="
      text-align:center;
      margin-top:20px;
      color:#777;
    ">


    Designed by:
    Chris - Polu Integrated Technology


    </div>


    `;





    html2pdf()

    .set({

      margin:10,

      filename:

      `attendance_${selectedClass.name}.pdf`,


      image:{

        type:"jpeg",

        quality:.98

      },


      html2canvas:{

        scale:2

      },


      jsPDF:{

        format:"a4",

        orientation:"portrait"

      }


    })


    .from(container)

    .save();



  };










  return (
<Box sx={styles.page}>
   <Box maxWidth="1000px" mx="auto">
      {/* HEADER */}
    <Box sx={styles.header}>


        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
        >


          <Avatar

            sx={{

              width:60,

              height:60,

              background:theme.white,

              color:theme.primary

            }}

          >

            <School/>

          </Avatar>




          <Box>


          <Typography

            variant="h5"

            fontWeight="bold"

          >

            Attendance Management

          </Typography>



          <Typography>

            Monitor student attendance records

          </Typography>



          </Box>



        </Stack>


      </Box>







      {/* FILTER SECTION */}



      <Paper sx={styles.filterCard}>


        <Grid container spacing={2}>


          <Grid item xs={12} md={6}>


          <Autocomplete


            fullWidth


            options={gradeClasses}


            getOptionLabel={
              option=>option.name
            }


            value={selectedClass}


            onChange={
              (_,value)=>
              setSelectedClass(value)
            }


            renderInput={
              params=>(


              <TextField

              {...params}

              label="Select Grade Class"

              />


              )

            }


          />


          </Grid>






          <Grid item xs={12} md={6}>


          <TextField


            fullWidth


            label="Search Student"


            value={search}


            onChange={
              e=>
              setSearch(e.target.value)
            }


            InputProps={{

              startAdornment:

              <Search/>

            }}


          />


          </Grid>



        </Grid>


      </Paper>







      {
        selectedClass &&


        <Stack

          direction={
            isMobile
            ?
            "column"
            :
            "row"
          }

          spacing={2}

          mb={3}

        >



        <Button

          startIcon={<Print/>}

          variant="outlined"

          onClick={handlePrint}

          sx={{

            borderColor:theme.primary,

            color:theme.primary

          }}

        >

          Print Attendance

        </Button>





        <Button


          startIcon={<PictureAsPdf/>}


          variant="contained"


          onClick={handleExportPDF}


          sx={styles.primaryButton}


        >

          Export PDF

        </Button>


        </Stack>


      }








      {/* STUDENT PROFILE */}



      {
        selectedStudent &&
        summaryCounts &&



        <Card sx={styles.studentCard}>


        <CardContent>


        <Stack


          direction={

            isMobile

            ?

            "column"

            :

            "row"

          }


          alignItems="center"


          spacing={3}


        >



        <Avatar


          src={
            selectedStudent.student_profile_image
          }


          sx={{

            width:80,

            height:80,

            background:theme.primary

          }}


        >


        {
          selectedStudent.student_name
          ?.charAt(0)

        }


        </Avatar>






        <Box>


        <Typography

          variant="h6"

          fontWeight="bold"

        >

        {selectedStudent.student_name}


        </Typography>


        <Typography color="text.secondary">

        Attendance Summary


        </Typography>


        </Box>




        <Stack

          direction="row"

          spacing={1}

          flexWrap="wrap"

          justifyContent="center"

        >



        <Chip

          label={
          `Present ${summaryCounts.present}`
          }

          color="success"

        />



        <Chip

          label={
          `Absent ${summaryCounts.absent}`
          }

          color="error"

        />



        <Chip

          label={
          `Late ${summaryCounts.late}`
          }

          color="warning"

        />



        <Chip

          label={
          `Excuse ${summaryCounts.excuse}`
          }

          color="info"

        />



        {
          hasDropped &&

          <Chip

            label="Dropped"

            sx={{

              background:"red",

              color:"#fff"

            }}

          />

        }



        </Stack>




        </Stack>



        </CardContent>


        </Card>


      }








      {/* TABLE */}



      <div ref={printRef}>


      <Paper sx={styles.tableCard}>


      <Table stickyHeader size="small">



      <TableHead>


      <TableRow>


      <TableCell>
      Date
      </TableCell>


      <TableCell>
      Student
      </TableCell>


      <TableCell>
      Status
      </TableCell>



      {!isMobile &&

      <TableCell>

      Actions

      </TableCell>

      }



      </TableRow>


      </TableHead>






      <TableBody>


      {

      paginatedRecords.map(
        record=>(


        <TableRow

        hover

        key={record.id}

        >


        <TableCell>

        {record.date}

        </TableCell>





        <TableCell>


        <Button


          onClick={()=>
          handleStudentClick(record)
          }


          sx={{

            textTransform:"none"

          }}


        >

        {record.student_name}

        </Button>


        </TableCell>





        <TableCell>


        <Chip


          label={

          record.status
          .charAt(0)
          .toUpperCase()
          +
          record.status.slice(1)

          }


          color={
          statusColors[
          record.status
          ]
          }


        />



        </TableCell>







        {!isMobile &&


        <TableCell>


        <IconButton

        onClick={()=>
        openEdit(record)
        }

        >


        <Edit/>

        </IconButton>




        <IconButton

        color="error"

        onClick={()=>
        handleDelete(record.id)
        }

        >


        <Delete/>

        </IconButton>


        </TableCell>


        }



        </TableRow>


        )

      )


      }


      </TableBody>



      </Table>






      <TablePagination


        component="div"


        count={
          filteredRecords.length
        }


        page={page}


        onPageChange={handleChangePage}


        rowsPerPage={rowsPerPage}


        rowsPerPageOptions={[
          rowsPerPage
        ]}


      />



      </Paper>


      </div>









      {/* EDIT DIALOG */}



      <Dialog

      open={Boolean(editRecord)}

      onClose={()=>
      setEditRecord(null)
      }

      fullWidth

      maxWidth="xs"


      >



      <DialogTitle>

      Edit Attendance

      </DialogTitle>



      <DialogContent>


      <FormControl

      fullWidth

      margin="normal"

      >


      <InputLabel>

      Status

      </InputLabel>



      <Select


      value={editStatus}


      label="Status"


      onChange={
        e=>
        setEditStatus(
        e.target.value
        )
      }


      >


      <MenuItem value="present">
      Present
      </MenuItem>


      <MenuItem value="absent">
      Absent
      </MenuItem>


      <MenuItem value="late">
      Late
      </MenuItem>


      <MenuItem value="excuse">
      Excused
      </MenuItem>


      <MenuItem value="drop">
      Dropped
      </MenuItem>


      </Select>


      </FormControl>


      </DialogContent>






      <DialogActions>


      <Button

      onClick={()=>
      setEditRecord(null)
      }

      >

      Cancel

      </Button>




      <Button

      variant="contained"

      onClick={handleUpdate}

      sx={styles.primaryButton}

      >

      Update

      </Button>



      </DialogActions>



      </Dialog>





    </Box>


  </Box>


  );



};



export default AttendanceData;


